import type { Types, WSIGenericViewport } from '@cornerstonejs/core';
import {
  RenderingEngine,
  Enums,
  getRenderingEngine,
  utilities,
} from '@cornerstonejs/core';
import * as cornerstoneTools from '@cornerstonejs/tools';
import dicomImageLoader from '@cornerstonejs/dicom-image-loader';
import { api } from 'dicomweb-client';

import {
  initDemo,
  setTitleAndDescription,
  createImageIdsAndCacheMetaData,
  getLocalUrl,
  addButtonToToolbar,
  addManipulationBindings,
} from '../../../../utils/demo/helpers';

// This is for debugging purposes
console.warn(
  'Click on index.ts to open source code for this example --------->'
);

const { ToolGroupManager } = cornerstoneTools;
const { wadors } = dicomImageLoader;
const { ViewportType } = Enums;

const renderingEngineId = 'myRenderingEngine';
const viewportId = 'wsiGenericViewport';
const wsiDataId = 'wsi-next:primary';

setTitleAndDescription(
  'WSI GenericViewport',
  'Demonstrates whole slide imaging with the clean GenericViewport WSI API.'
);

addButtonToToolbar({
  title: 'Zoom In',
  onClick: () => {
    const renderingEngine = getRenderingEngine(renderingEngineId);
    const viewport =
      renderingEngine.getViewport<WSIGenericViewport>(viewportId);

    viewport.setZoom(2 * viewport.getZoom());
    viewport.render();
  },
});

addButtonToToolbar({
  title: 'Disable Viewport',
  onClick: () => {
    const renderingEngine = getRenderingEngine(renderingEngineId);
    renderingEngine?.disableElement(viewportId);
  },
});

const content = document.getElementById('content');
const element = document.createElement('div');
element.id = 'cornerstone-element';
element.oncontextmenu = () => false;
element.style.width = '512px';
element.style.height = '512px';

content.appendChild(element);

function createToolGroup(toolGroupId = 'default') {
  const toolGroup = ToolGroupManager.createToolGroup(toolGroupId);
  addManipulationBindings(toolGroup);

  return toolGroup;
}

async function run() {
  await initDemo();

  const toolGroupId = 'default';
  const toolGroup = createToolGroup(toolGroupId);

  const wadoRsRoot =
    getLocalUrl() || 'https://d14fa38qiwhyfd.cloudfront.net/dicomweb';
  const client = new api.DICOMwebClient({ url: wadoRsRoot });
  const imageIds = await createImageIdsAndCacheMetaData({
    StudyInstanceUID: '2.25.269859997690759739055099378767846712697',
    SeriesInstanceUID: '2.25.274641717059635090989922952756233538416',
    client,
    wadoRsRoot,
    convertMultiframe: false,
  });

  const renderingEngine = new RenderingEngine(renderingEngineId);

  renderingEngine.enableElement({
    viewportId,
    type: ViewportType.WHOLE_SLIDE_NEXT,
    element,
    defaultOptions: {
      background: [0, 0.2, 0] as Types.Point3,
    },
  });

  const viewport = renderingEngine.getViewport<WSIGenericViewport>(viewportId);

  client.getDICOMwebMetadata = (imageId) => wadors.metaDataManager.get(imageId);

  utilities.genericViewportDisplaySetMetadataProvider.add(wsiDataId, {
    imageIds,
    kind: 'wsi',
    options: { webClient: client },
  });
  await viewport.setDisplaySets({ displaySetId: wsiDataId });

  toolGroup.addViewport(viewportId, renderingEngineId);
}

run();
